import { render } from "./SelectorLanguage.vue?vue&type=template&id=1088347f&scoped=true"
import script from "./SelectorLanguage.vue?vue&type=script&lang=js"
export * from "./SelectorLanguage.vue?vue&type=script&lang=js"

import "./SelectorLanguage.vue?vue&type=style&index=0&id=1088347f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1088347f"]])

export default __exports__